(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
  var cookiePopup = document.getElementById("cookiePopup");
  var acceptCookies = document.getElementById("acceptCookies");

  function getCookie(name) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + name + "=");
      if (parts.length === 2) return parts.pop().split(";").shift();
  }

  if (!getCookie("cookies_accepted")) {
      setTimeout(function() {
          cookiePopup.classList.add("show");
      }, 1000);
  }

  acceptCookies.addEventListener("click", function() {
      cookiePopup.classList.remove("show");
      document.cookie = "cookies_accepted=true; max-age=31536000; path=/";
  });
});



  const menus = document.querySelectorAll('.menu');

    menus.forEach(menu => {
        const toggle = menu.querySelector("#menu-toggle");
        const mobileMenu = menu.querySelector("#mobile-menu");
        const menuIcon = menu.querySelector("#menu-icon");

        toggle.addEventListener("click", function() {
            // Alterna a classe "ativo" no mobileMenu
            mobileMenu.classList.toggle("ativo");

            // Alterna entre "+" e "-"
            if (mobileMenu.classList.contains("ativo")) {
                mobileMenu.style.display = "block";
                menuIcon.textContent = "-";
            } else {
                mobileMenu.style.display = "none";
                menuIcon.textContent = "+";
            }
        });
    });


  } catch(e) { console.error(e); }
})();
})();
